export function shortId(id: string, keep = 8): string {
  if (id.length <= keep + 4) return id;
  return `${id.slice(0, keep)}…`;
}

/** Compact id display: leading characters only (no ellipsis). */
export function idPrefix(id: string, length = 8): string {
  return id.slice(0, length);
}
